
import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import { IUserQuotas, UserDocument, UserPayload, UserStatsDocument } from "@/interfaces/user.interfaces";
import { ajustHeight } from '@/shared/dom.utils';
import { resetPassword, UserStats } from "@/axios/axios.user";
import { strDatetime } from "@/shared/datetime.utils";


@Component
export default class SAccUsersDetail extends Vue {
  // Les props
  @Prop({default: null}) private user!: UserDocument | null
  @Prop({default: false}) private edit!: boolean
  @Prop({default: false}) private add!: boolean
  @Prop() private usedQuotas!: IUserQuotas
  @PropSync('payload') private ccData!: UserPayload
  @PropSync('valid') private isValid!: boolean

  // Les propriétés
  private height: string = ''
  private stats: UserStatsDocument | null = null
  private formatDate = strDatetime
  private required = (v: string) => v && v.length > 0 || 'This field is required'
  private emailRules = (v: string) => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'


  // Les propriétés calculées
  private get theme(): string {
    return this.$store.state.theme
  }

  private get userUsage(): boolean {
    return this.stats && this.user ? this.stats.used : true
  }

  private get exceededQuota(): boolean {
    // console.log(`exceededQuota edit:${this.edit}, isActive:${this.ccData.isActive}`)
    const supEgal = this.edit && !this.ccData.isActive
    return this.xQuota(supEgal)
  }

  private get exceededQuotaMessage(): string {
    return this.exceededQuota ? `Exceeded ${this.ccData.capacity} quota` : ''
  }

  private get userHasPassword() {
    return this.user && this.user.authid && this.user.authid.password && this.user.authid.password.length > 0
  }

  // Les hooks
  public mounted() {
    window.addEventListener('resize', this.ajustHeight)
  }

  public beforeDestroy() {
    window.removeEventListener('resize', this.ajustHeight)
  }

  // Les méthodes surveillées
  @Watch('user')
  private async changeUser() {
    // this.ccData = this.user ? {...this.user, ...this.user.authid} : {...emptyData}
    if (this.user) {
      this.stats = await UserStats(this.user._id)
    }
    this.$nextTick(this.ajustHeight)
  }

  @Watch('edit')
  private onEdit() {
    this.$nextTick(this.ajustHeight)
  }

  @Watch('ccData.capacity')
  private onChangeCapacity() {
    if (this.exceededQuota) {
      this.ccData.isActive = false
    }
  }

  // Les méthodes d'instance
  private ajustHeight() {
    this.height = `${ajustHeight('userdetail', 52)}px`
  }

  private xQuota(supEgal: boolean = false) {
    const uq: IUserQuotas = this.$store.getters['userQuotas']
    const c = this.ccData.capacity as 'tester' | 'guest' | 'certifier'
    const plusUn = supEgal ? 1 : 0
    // console.log(`xQuota ${this.usedQuotas[c]} + ${plusUn} > ${uq[c]}`)
    return this.usedQuotas[c] + plusUn > uq[c]
  }

  private async resetPassword() {
    if (this.user && this.user.authid) {
      await resetPassword(this.user.authid._id)
      this.user.authid.password = ''
    }
  }

  // Les méthodes statiques

}
